module.exports = __webpack_public_path__ + "02_bob_black.5029ec5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/02_bob_black.png
// module id = dY9C
// module chunks = 0